/*
 * Merchant: "go through and put items where they need to be" — a full audit
 * of the catalog found roughly 150 real, in-stock products that never show
 * up under any of the six built-in department chips (Field Gear/Uniforms/
 * Aviation/Comms/Load-Bearing), only under "All": Collective imports whose
 * own product.type is either blank or a real-but-differently-spelled value
 * ("Sleeping Bag", "Rucksack", "Holster", "Outerwear", "Watches" — never
 * exactly "Field Gear"/"Uniforms"/etc.), so the built-in filter's plain
 * p.cat===activeCat check never matches them.
 *
 * Rather than overwrite product.type to force a match — which would blur
 * real, specific catalog data for no reason, the same call already made for
 * Modern Tactical/Other/Knives in assets/sat-modern-department-patch.js —
 * this adds a small, additive tag convention: tagging a product with the
 * exact department name ("Field Gear", "Uniforms", "Aviation", "Comms" or
 * "Load-Bearing") surfaces it under that chip too, without touching its own
 * product.type or the CATEGORY the product detail modal shows for it. See
 * snippets/sat-bootstrap.liquid for where deptOverride is computed and
 * where the same tag convention now also drives a sensible default `cat`
 * for the (much smaller) set of products with no product.type at all.
 *
 * Wraps SATComponent.prototype.visibleProducts once more, only for the five
 * built-in department labels — the four extra chips (Modern Tactical/Other/
 * Books/Knives) are untouched, already handled by
 * assets/sat-modern-department-patch.js. Loads after that patch (so it only
 * ever needs to special-case real built-in labels) and before
 * assets/sat-random-sort-patch.js, so the extra matches get shuffled and
 * search-filtered exactly like the rest of that department's listing.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var BUILTIN_DEPARTMENTS = ['Field Gear', 'Uniforms', 'Aviation', 'Comms', 'Load-Bearing'];

  var proto = window.SATComponent.prototype;

  var origVisibleProducts = proto.visibleProducts;
  proto.visibleProducts = function () {
    var activeCat = this.state.activeCat;
    if (BUILTIN_DEPARTMENTS.indexOf(activeCat) === -1) { return origVisibleProducts.call(this); }
    var base = origVisibleProducts.call(this);
    var q = String(this.state.query || '').trim().toLowerCase();
    var extra = this._products.filter(function (p) {
      if (p.cat === activeCat || p.deptOverride !== activeCat) { return false; }
      var qOk = !q || (p.name + ' ' + p.cat + ' ' + p.era + ' ' + p.id + ' ' + p.blurb).toLowerCase().indexOf(q) !== -1;
      return qOk;
    });
    if (!extra.length) { return base; }
    var combined = base.concat(extra);
    if (this.state.sortBy === 'Price, Low to High') { combined.sort(function (a, b) { return a.price - b.price; }); }
    if (this.state.sortBy === 'Price, High to Low') { combined.sort(function (a, b) { return b.price - a.price; }); }
    if (this.state.sortBy === 'Oldest Era') { combined.sort(function (a, b) { return a.era.localeCompare(b.era); }); }
    return combined;
  };
})();
